/*
 * @Description:
 * @Date: 2024-01-11 14:07:18
 */

const views = (require as any).context(
  './',
  true,
  /pc-module-background-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});

const _str = `乳腺病的前沿治疗方法相较于传统的手术治疗和放疗，主要包括化学药物治疗、内分沙治疗和向治疗等，具体如下:
1.化学药物治疗:其目的是通过药物来缩小病灶，减少癌细胞。常用化疗药物包括多柔比星表柔比星、紫杉醇、多西他赛等，但要根据对药物的敏,感程喜以及化疗后的效果来选择
2.内分沙治疗:其主要的作用是通过抑制或阳断激索来达到治疗目的。可使用抗难激衰药物如托瑞米芬、他莫首芬等，也可以使用芳香酶抑制剂，如来曲哇、阿那曲哗等.`;
export const _testBackgroundData = {
  info: new Array(15)
    .fill(null)
    .map(
      () =>
        `<p style="font-size:${
          parseInt(Math.random() * 32) + 12
        }px;line-height:1.8;">${_str}</p>`
    )
    .join('')
};
